module.exports = __webpack_public_path__ + "02_long_grey.658d8982.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_long_grey.png
// module id = WTwX
// module chunks = 0